<script>
  import { FormGroup } from '@xhs/yam-beer'
  import { FormItemBase, RemoveButton } from '@xhs/vue-formily'

  export default {
    name: 'BeerFormItem',

    components: {
      FormGroup,
      RemoveButton,
    },

    extends: FormItemBase,
    computed: {
      labelTooltip() {
        if (typeof this.tooltip === 'string') {
          return {
            content: this.tooltip,
          }
        }
        if (typeof this.tooltip === 'object') {
          return this.tooltip
        }
        return undefined
      },
    },
  }
</script>

<template>
  <form-group
    :label="label"
    :required="required"
    :layout="isHorizontal ? 'table' : undefined"
    :error-text="validationMessage ? validationMessage : undefined"
    :label-info="comment"
    :helper-text="helperText"
    :label-tooltip="labelTooltip"
  >
    <div class="input-container">
      <slot />

      <remove-button
        v-if="showRemove"
        @click="emitRemove"
      />
    </div>
  </form-group>
</template>

<style lang="stylus" scoped>
.input-container
  display flex
  justify-content space-between
</style>
